import { Injectable } from '@angular/core';
import { AccountRegistrationResponse } from '@interfaces';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { sanitizeError } from '@shared/helpers/sanitize-error-helper';
import { LoggerCodes } from '@shared/modules/logger/constants/logger.constants';
import { AccountRegistrationService } from '@shared/services';
import { LogError, RedirectToPVR } from '@store/actions';
import {
  LoadAccountRegistrations,
  UpdateAccountRegistrations,
} from '@store/actions/account-registrations/account-registrations.actions';
import { switchMap, tap } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable()
export class AccountRegistrationEffects {
  constructor(
    private actions$: Actions,
    private accountRegistrationService: AccountRegistrationService,
  ) {}

  loadAccountRegistrations$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LoadAccountRegistrations),
      switchMap(() =>
        this.accountRegistrationService
          .callAccountRegistration()
          .pipe(
            map((accReg: AccountRegistrationResponse) =>
              UpdateAccountRegistrations({ payload: accReg.accountRegistrations }),
            ),
          ),
      ),
      catchError((e) => {
        return [
          LogError({
            payload: {
              eventId: 'error-account-registrations-load-failure',
              message: `Account registration endpoint answered with error: ${JSON.stringify(sanitizeError(e))}`,
              loggerCode: LoggerCodes.NULL_FAILURE,
            },
          }),
        ];
      }),
    ),
  );
}
